import { render } from "./FormError.vue?vue&type=template&id=5751e19b"
import script from "./FormError.vue?vue&type=script&lang=js"
export * from "./FormError.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/FormError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5751e19b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5751e19b', __exports__)) {
    api.reload('5751e19b', __exports__)
  }
  
  module.hot.accept("./FormError.vue?vue&type=template&id=5751e19b", () => {
    api.rerender('5751e19b', render)
  })

}


export default __exports__